
import React from 'react';
import ReactDOM from 'react-dom'; 
 import Main from "./containers/index";


ReactDOM.render(<Main />, document.querySelector('#root'));
       